(function() {

  // --- TVG debug toggle ------------------------------------
  // Flip this to false to silence all debug output from custom.js
  var TVG_DEBUG = true;

  function tvgLog() {
    if (!TVG_DEBUG || !window.console || !console.log) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[custom.js]");
    console.log.apply(console, args);
  }

  function tvgWarn() {
    if (!TVG_DEBUG || !window.console || !console.warn) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[custom.js]");
    console.warn.apply(console, args);
  }

  function tvgError() {
    if (!TVG_DEBUG || !window.console || !console.error) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[custom.js]");
    console.error.apply(console, args);
  }

  // TVG: helper - convert a unit price from major currency units to cents.
  // The content attribute always holds Shopify Liquid's current_variant.price
  // which is in major units (e.g. 34 = EUR 34.00, 200 = SAR 200.00).
  // formatMoney() expects cents/sub-units, so we always multiply by 100.
  function tvgParseUnitCents(rawAttr) {
    const raw = Number(rawAttr) || 0;
    return Math.round(raw * 100);
  }

  // ---------------------------------------------------------
  // TVG 2025-11 – detect which customisation template we're on
  // ---------------------------------------------------------

  const tvgCustomRoot =
    document.querySelector(".custom-fields") ||
    document.querySelector(".custom-fields-velvet");

  const TVG_TEMPLATE_ID = tvgCustomRoot
    ? tvgCustomRoot.getAttribute("data-product-template") || ""
    : "";

  let TVG_PRODUCT_KIND = "none";

  if (
    TVG_TEMPLATE_ID === "product.custom-size-rectangular" ||
    TVG_TEMPLATE_ID === "product.custom-size-circular"
  ) {
    TVG_PRODUCT_KIND = "custom-size";
  } else if (TVG_TEMPLATE_ID === "product.custom-length") {
    TVG_PRODUCT_KIND = "length";
  } else if (
    TVG_TEMPLATE_ID === "product.custom-velvet-curtain" ||
    TVG_TEMPLATE_ID === "product.custom-size-fixed-width"
  ) {
    TVG_PRODUCT_KIND = "velvet/fixed-width";
  }

  tvgLog("[product] template detect", {
    templateId: TVG_TEMPLATE_ID,
    kind: TVG_PRODUCT_KIND
  });

  // Basic boot log
  tvgLog("called custom js");

  let sizeGuideAttempts = 0;
  const HideLabelInterval = setInterval(() => {
    // Reveal the size-guide tooltip on dropdown pickers, but ONLY on genuine
    // size options. The theme renders the tooltip (.variant__label-info, hidden
    // via "hide") on EVERY option when a size chart exists (the
    // block.settings.size_chart.content fallback in variant-dropdown.liquid),
    // so revealing all of them wrongly showed it on "Style", "Prix", etc.
    // variant-dropdown.liquid now tags the real size option's wrapper with
    // `.is-size-option` (its name matches the theme's localized size trigger,
    // e.g. "Taille" / "Taille du matelas"), so we scope the reveal to that.
    const infos = document.querySelectorAll('.variant-wrapper--dropdown.is-size-option .variant__label-info.hide');
    infos.forEach(info => info.classList.remove('hide'));
    if (infos.length > 0 || ++sizeGuideAttempts >= 60) {
      clearInterval(HideLabelInterval);
    }
  }, 50);

  if (document.querySelector(".add_cart_btn__hide")) {
      let optionsSetInterval = setInterval(function() {
          function _handleChange(e) {
              if (e.currentTarget.hasAttribute("previous-value")) {
                  if (e.currentTarget.getAttribute("previous-value") == "checked") {
                      if (document.querySelector("#AddToCart-calc").classList.contains("hide")) {
                          //console.log("yes")
                          document.querySelector(".product-single__form").querySelector("button[name='add']").style.display = "block";
                      }
                  } else {
                      clearInterval(optionsSetInterval)
                  }
              }
          }
          document.querySelectorAll("input[name='Couleur']").forEach((input) => {
              input.addEventListener("change", _handleChange.bind(this), true);
          })

      }, 1000)
  }
  const loadImagesWithAlt = selectedColor => {
      selectedColor = selectedColor.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ', '-');
      //     console.log("Normalized Selected Color", selectedColor);
      if (selectedColor == "") return;
      let optionName = selectedColor.includes("_") ? selectedColor.split("_")[0] : "colour_";
      let selectedAltText = `${optionName}${selectedColor}`;
      let imageArray = new Array(),
          thumbsArray = new Array();

      document.querySelector(".product-images-with-alt").querySelectorAll(".product-main-slide")
          .forEach((slide) => {
              let setName = slide.getAttribute("data-set-name") ? slide.getAttribute("data-set-name") : "";
              let groupName = slide.getAttribute("data-group") ? slide.getAttribute("data-group") : "";
              if (setName.length && groupName.length) {
                  if (slide.getAttribute("data-set-name") == optionName.replace("_", "") && slide.getAttribute("data-group").toLowerCase() == selectedAltText) {
                      imageArray.push(slide.cloneNode(true));
                  }
              }
              if (setName == "" && groupName == "") {
                  imageArray.push(slide.cloneNode(true));
              }
          });

      document.querySelector(".product__thumbs-with-alt").querySelectorAll(".product__thumb-item")
          .forEach((thumbSlide) => {
              let setName = thumbSlide.getAttribute("data-set-name") ? thumbSlide.getAttribute("data-set-name") : "";
              let groupName = thumbSlide.getAttribute("data-group") ? thumbSlide.getAttribute("data-group") : "";
              if (setName.length && groupName.length) {
                  if (thumbSlide.getAttribute("data-set-name") == optionName.replace("_", "") && thumbSlide.getAttribute("data-group").toLowerCase() == selectedAltText) {
                      thumbsArray.push(thumbSlide.cloneNode(true));
                  }
              }
              if (setName == "" && groupName == "") {
                  thumbsArray.push(thumbSlide.cloneNode(true));
              }
          });

      if (imageArray.length) {
          let slider = Flickity.data(document.querySelector('.product-slideshow'));
          if (slider) slider.destroy();
          document.querySelector('.product-slideshow').innerHTML = "";
          let count = 0;
          //imageArray.reverse();
          for (let image of imageArray) {
              if (count == 0) {
                  image.classList.remove("starting-slide", "secondary-slide", "is-selected");
                  image.classList.add("starting-slide");
              }
              image.setAttribute("data-index", count);
              document.querySelector(".product-slideshow").insertAdjacentHTML("beforeend", image.outerHTML);
              count++;
          }
          window.initCustomProductSlider();

          document.querySelector(".product__thumbs--scroller").querySelectorAll(".product__thumb-item").forEach(function(thumbInstance) {
              let thumbSetName = thumbInstance.getAttribute("data-set-name") ? thumbInstance.getAttribute("data-set-name") : "";
              let thumbGroupName = thumbInstance.getAttribute("data-group") ? thumbInstance.getAttribute("data-group").toLowerCase() : "";
              (thumbSetName == optionName.replace("_", "") && thumbGroupName == selectedAltText) ? thumbInstance.classList.remove("hide"): thumbInstance.classList.add("hide");
          });

          document.querySelector(".product__thumbs--scroller").innerHTML = "";
          let thumbCount = 0;
          //thumbsArray.reverse();
          for (let thumb of thumbsArray) {
              if (thumbCount == 0) {
                  thumb.querySelector(".product__thumb").classList.remove("is-active");
                  thumb.querySelector(".product__thumb").classList.add("starting-slide");
              }
              thumb.querySelector(".product__thumb").setAttribute("data-index", thumbCount);
              thumb.classList.remove("hide");
              document.querySelector('.product__thumbs--scroller').insertAdjacentHTML("beforeend", thumb.outerHTML);
              thumbCount++;
          }
          document.querySelector(".product__thumbs--scroller").querySelectorAll(".product__thumb-item:not(.hide)")[0].querySelector(".product__thumb").classList.add("is-active");
          window.initCustomImageZoom(document.querySelector(".product-section"));
      }
  }

  window.addEventListener("click", function(event) {
      if (!event.target.closest(".product__thumb")) return;
      event.preventDefault();
      document.querySelectorAll(".product__thumb").forEach(function(thumbInstance) {
          thumbInstance.classList.remove("is-active");
      });
      event.target.closest(".product__thumb").classList.add("is-active");
      let index = parseInt(event.target.closest(".product__thumb").getAttribute("data-index"));
      if (Flickity.data(document.querySelector('.product-slideshow'))) {
          Flickity.data(document.querySelector(".product-slideshow")).select(index);
      }
  });

  function boldOptionChangeEvent(event) {
      let isChecked = event.target.checked;
      let input = event.target;
      if (isChecked) {
          let selectedValue = (input.getAttribute("value")).toLowerCase().replace(" ", "-");
          loadImagesWithAlt(selectedValue);
      }
  }
  let optionsSetInterval = setInterval(function() {
    let boldOption = document.querySelectorAll(".gpo-swatches");
    if(boldOption.length){
       clearInterval(optionsSetInterval);
        boldOption.forEach(function(option) {
        if(option){
          option.querySelector("input").addEventListener("change", boldOptionChangeEvent.bind(this), true);
        }        
    });
    }
    
  }, 1000)

  /*-- Template Code --*/
  function parameterChanged(event) {
      document.querySelector("#AddToCart-calc").classList.remove("hide");
      document.querySelector(".add_cart_btn__hide").classList.remove("show_addtocart");
      if (document.querySelector(".product-single__form").querySelector("button[name='add'].gpo-clone-atc-button")) {
          document.querySelector(".product-single__form").querySelector("button[name='add'].gpo-clone-atc-button").style.display = "none";
      } else {
          document.querySelector(".product-single__form").querySelector("button[name='add']").style.display = "none";
      }

  }

  function _handleQtyChange(e) {
      let target = e.currentTarget;
      if (target.getAttribute("data-operator") == "minus") {
          let currentValue = parseInt(target.closest(".js-qty__wrapper_number").querySelector("input").value);
          let newValue = currentValue - 1;
          if (newValue > 0) {
              target.closest(".js-qty__wrapper_number").querySelector("input").value = newValue;
          } else {
              target.closest(".js-qty__wrapper_number").querySelector("input").value = 1;
          }

      }

      if (target.getAttribute("data-operator") == "plus") {
          let currentValue = parseInt(target.closest(".js-qty__wrapper_number").querySelector("input").value);
          let newValue = currentValue + 1;
          if (newValue > 0) {
              target.closest(".js-qty__wrapper_number").querySelector("input").value = newValue;
          } else {
              target.closest(".js-qty__wrapper_number").querySelector("input").value = 1;
          }

      }


  }

  let qtyManipulator = document.querySelectorAll(".js-number-of-pieces-manipulator");
  if (qtyManipulator.length) {
      qtyManipulator.forEach((manipulator) => {
          manipulator.addEventListener("click", _handleQtyChange.bind(this), true);
          manipulator.addEventListener("click", parameterChanged.bind(this), true);

      })
  }
  if (document.querySelector(".custom-fields") && document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-length") {
      document.querySelector("#customLength").addEventListener("keydown", function(event) {
          if (event.key == "Enter") {
              event.preventDefault();
              return;
          }
      }, );
  }
  if (document.querySelector(".custom-fields-velvet") && document.querySelector(".custom-fields-velvet").getAttribute("data-product-template") == "product.custom-velvet-curtain") {
      document.querySelector("#customLength").addEventListener("keydown", function(event) {
          if (event.key == "Enter") {
              event.preventDefault();
              return;
          }
      }, );
  }

      let productPriceElement = document.querySelector(`[data-product-price]`);
      // TVG 2025-03 – guard against missing .money span (not rendered on
      // non-UK markets for custom-length products).  initialPrice was dead
      // code (block-scoped, never read elsewhere) but the null-dereference
      // crashed the entire IIFE, preventing all event listeners below from
      // being registered.
      if(document.querySelector(`[data-product-price]`)){
        const _moneyEl = productPriceElement.querySelector(".money");
        let initialPrice = _moneyEl ? _moneyEl.innerHTML : "";
      }
      let $targetMeasurementField = document.querySelectorAll(".mesurement");
      let $userQty = document.querySelector("#user_quantity");
      let priceCalculatingButton = document.querySelector("#AddToCart-calc");
      let mearurementErrorMsg = document.querySelector(".m-error");
      let qtyErrorMsg = document.querySelector(".q-error");
      let compareAtPriceElement = document.querySelector("[data-compare-price]");
      let savePriceElement = document.querySelector("[data-save-price]");
    
      if(document.querySelector(".custom-fields")){
      if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-rectangular") {
          $targetMeasurementField.forEach(function(measurementInput) {
              measurementInput.addEventListener("change", parameterChanged.bind(this), true);
          });
          $userQty.addEventListener("change", parameterChanged.bind(this), true);
      }
      if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-circular") {
          $targetMeasurementField.forEach(function(measurementInput) {
              measurementInput.addEventListener("keyup", parameterChanged.bind(this), false);
          });
          $userQty.addEventListener("keyup", parameterChanged.bind(this), false);
      }
      if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-length") {
          $targetMeasurementField.forEach(function(measurementInput) {
              measurementInput.addEventListener("input", parameterChanged.bind(this), true);
          });
          $userQty.addEventListener("change", parameterChanged.bind(this), true);
      }
        
      priceCalculatingButton.addEventListener("click", function() {
          if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-rectangular") {
              let customWidth = Number(document.querySelector("#width").value);
              let customLength = Number(document.querySelector("#length").value);
             
              if (customLength < 1 ) {
                  qtyErrorMsg.classList.remove("hide");
                  return;
              }
              qtyErrorMsg.classList.add("hide");
              if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-rectangular") {
                  if (customWidth < 100) {
                     document.querySelector(".m-error").classList.remove("hide");
                      //document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
                      return;
                  }
              }

              let multiply = 1;
              let actual_quantity;
              let currentUserQty = Number($userQty.value);
              $targetMeasurementField.forEach((measurementElement) => {
                  multiply = multiply * Number(measurementElement.value);

              });

            tvgLog("[custom-size] init", {
            template: TVG_TEMPLATE_ID,
            kind: TVG_PRODUCT_KIND,
            multiply: multiply
            });              

              if (currentUserQty > 0 && multiply > 0) {
                  mearurementErrorMsg.classList.add("hide");
                  qtyErrorMsg.classList.add("hide");
                  document.querySelector("#AddToCart-calc").classList.add("hide");
                  document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
                  if (document.querySelector(".product-single__form").querySelector("button[name='add'].gpo-clone-atc-button")) {

                      document.querySelector(".product-single__form").querySelector("button[name='add'].gpo-clone-atc-button").style.display = "block";
                  } else {

                      document.querySelector(".product-single__form").querySelector("button[name='add']").style.display = "block";
                  }

                  actual_quantity = multiply * currentUserQty;
                  actual_quantity = Math.round(actual_quantity / 100);
                  if (actual_quantity < 1) {
                      document.querySelector(".product-single__form").querySelector("input[name='quantity']").value = 1;
                  } else {
                      document.querySelector("input[name='quantity']").value = actual_quantity;
                  }
                  update_price(actual_quantity);

              } else {
                  if (currentUserQty <= 0) {
                      if (qtyErrorMsg.classList.contains("hide")) {
                          qtyErrorMsg.classList.remove("hide");
                      }
                  } else {
                      qtyErrorMsg.classList.add("hide");
                  }
               
                  if (multiply <= 0) {
                      if (mearurementErrorMsg.classList.contains("hide")) {
                          mearurementErrorMsg.classList.remove("hide");
                      }
                  } else {
                      mearurementErrorMsg.classList.add("hide");
                  }
              }
          }
          if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-size-circular") {
             let customDiameter = Number(document.querySelector("#diameter").value);
            if (customDiameter < 100 ) {
                  mearurementErrorMsg.classList.remove("hide");
                  return;
              }
              mearurementErrorMsg.classList.add("hide");
              let multiply = 1;
              let actual_quantity;
              let currentUserQty = Number($userQty.value);
              $targetMeasurementField.forEach((measurementElement) => {
                  multiply = multiply * Number(measurementElement.value);
              });


              if (currentUserQty > 0 && multiply > 0) {
                  mearurementErrorMsg.classList.add("hide");
                  qtyErrorMsg.classList.add("hide");
                  document.querySelector("#AddToCart-calc").classList.add("hide");
                  document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
                  if (document.querySelector(".product-single__form").querySelector("button[name='add'].bold_clone")) {
                      document.querySelector(".product-single__form").querySelector("button[name='add'].bold_clone").style.display = "block";
                  } else {
                      document.querySelector(".product-single__form").querySelector("button[name='add']").style.display = "block";
                  }


                  actual_quantity = (multiply / 2) * (multiply / 2) * 3.14;
                  actual_quantity = Math.round(actual_quantity / 100);
                  actual_quantity = actual_quantity * currentUserQty;
                  if (actual_quantity < 1) {
                      document.querySelector(".product-single__form").querySelector("input[name='quantity']").value = 1;
                  } else {
                      document.querySelector("input[name='quantity']").value = actual_quantity;
                  }
                
                  update_price(actual_quantity);
              } else {
                  if (currentUserQty <= 0) {
                      if (qtyErrorMsg.classList.contains("hide")) {
                          qtyErrorMsg.classList.removeClass("hide");
                      }

                  } else {
                      qtyErrorMsg.classList.add("hide");
                  }

                  if (multiply <= 0) {
                      if (mearurementErrorMsg.classList.contains("hide")) {
                          mearurementErrorMsg.classList.remove("hide");
                      }
                  } else {
                      mearurementErrorMsg.classList.add("hide");
                  }
              }
          }
          if (document.querySelector(".custom-fields").getAttribute("data-product-template") == "product.custom-length") {
              let customWidth = 1;
              let customLength = Number(document.querySelector("#customLength").value);
              if (customLength < 100) {
                  qtyErrorMsg.classList.remove("hide");
                  return;
              }
              qtyErrorMsg.classList.add("hide");
              document.querySelector("#user_quantity").value = customLength * customWidth;
              document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value = document.querySelector("#user_quantity").value * document.querySelector(`input[name='properties[${window.theme.strings.number_of_pieces}]']`).value;
              tvgLog("[length] computed quantity", {
                quantity: document
                    .querySelector(".product-single__meta")
                    .querySelector("input[name='quantity']").value
                });

              let finalQuantity = Number(document.querySelector(".product-single__meta").querySelector(`input[name='properties[${window.theme.strings.number_of_pieces}]']`).value);
              document.querySelector("#AddToCart-calc").classList.add("hide");
              document.querySelector(".add_cart_btn__hide").classList.add("show_addtocart");
              if (document.querySelector(".product-single__meta").querySelector("button[name='add'].bold_clone")) {
                  document.querySelector(".product-single__meta").querySelector("button[name='add'].bold_clone").style.display = "block";
              } else {
                  document.querySelector(".product-single__meta").querySelector("button[name='add']").style.display = "block";
              }
              let finalPrice = Number(document.querySelector(".product-single__meta").querySelector("input[name='quantity']").value) * Number(document.querySelector("[data-product-price]").getAttribute("content"));
              updatePrice(finalPrice * 100);
          }
          
      }, true);
    }

  // -----------------------------
  // Velvet / fixed-width templates
  // -----------------------------
  if (document.querySelector(".custom-fields-velvet")) {
    const velvetRoot     = document.querySelector(".custom-fields-velvet");
    const velvetTemplate = velvetRoot.getAttribute("data-product-template");

    tvgLog("[velvet] init", {
        template: TVG_TEMPLATE_ID,
        kind: TVG_PRODUCT_KIND,
      unitContent: productPriceElement && productPriceElement.getAttribute("content"),
      cmpContent: compareAtPriceElement && compareAtPriceElement.getAttribute("data-content")
    });

    // --- 1) Initial pricing message ---
    if (productPriceElement) {
      productPriceElement.innerHTML =
        window.theme.strings.custom_velvet_product;
      productPriceElement.style.visibility = "visible";
      tvgLog("[velvet] initial 'Confirm length' message shown");
    }

    // --- 2) Parameter change → show 'Calculate price' again ---
    if (
      velvetTemplate === "product.custom-velvet-curtain" ||
      velvetTemplate === "product.custom-size-fixed-width"
    ) {
      $targetMeasurementField.forEach(function (measurementInput) {
        measurementInput.addEventListener("input", parameterChanged.bind(this), true);
      });
      if ($userQty) {
        $userQty.addEventListener("change", parameterChanged.bind(this), true);
      }
    }

    // --- 3) Click on 'Calculate price' for velvet / fixed-width ---
    priceCalculatingButton.addEventListener(
      "click",
      function () {
        const velvetRoot = document.querySelector(".custom-fields-velvet");
        if (!velvetRoot) {
          tvgWarn("[velvet] click but no .custom-fields-velvet");
          return;
        }

        const template = velvetRoot.getAttribute("data-product-template");
        if (
          template !== "product.custom-velvet-curtain" &&
          template !== "product.custom-size-fixed-width"
        ) {
          // Let the normal rectangular / circular handler deal with it
          tvgLog("[velvet] click ignored for template", template);
          return;
        }

        const customWidth  = Number(document.querySelector("#customWidth").value);
        const customLength = Number(document.querySelector("#customLength").value);

        if (customLength < 100) {
          tvgLog("[velvet] length below min", { customLength });
          qtyErrorMsg.classList.remove("hide");
          return;
        }
        qtyErrorMsg.classList.add("hide");

        const widthCm  = customWidth;
        const lengthCm = customLength;
        const qty      = Number(
          document.querySelector(
            `input[name='properties[${window.theme.strings.number_of_pieces}]']`
          ).value
        );

        tvgLog("[velvet] inputs", { widthCm, lengthCm, qty });

        // Helper just for velvet: interpret either "0.41" (euros) or "41" (cents)
        const normaliseVelvetUnit = (raw) => {
          const str = String(raw || "").trim();
          if (!str) return 0;

          // If there's a decimal point, treat as euros already ("0.41")
          if (str.indexOf(".") !== -1) return Number(str) || 0;

          // No decimal point: treat as cents ("41" → 0.41)
          const n = Number(str) || 0;
          return n / 100;
        };

        // --- read unit prices, normalising to euros ---
        const baseUnitEuros = normaliseVelvetUnit(
          productPriceElement.getAttribute("content")
        );

        const compareAtUnitEuros = compareAtPriceElement
          ? normaliseVelvetUnit(compareAtPriceElement.getAttribute("data-content"))
          : 0;

        // --- area & units (100 cm²) ---
        const areaCm2       = widthCm * lengthCm;
        const unitsPerPanel = Math.ceil(areaCm2 / 100); // bill full 100 cm² units
        const totalUnits    = unitsPerPanel * qty;      // Shopify quantity

        // keep Shopify quantity in sync
        document.querySelector("#user_quantity").value = totalUnits;
        document
          .querySelector(".product-single__meta")
          .querySelector("input[name='quantity']").value = totalUnits;

        // --- totals in euros ---
        const baseTotalEuros = baseUnitEuros * totalUnits;
        const cmpTotalEuros  = compareAtUnitEuros * totalUnits;

        // convert once to cents for formatMoney
        const baseTotalCents = Math.round(baseTotalEuros * 100);
        const cmpTotalCents  = Math.round(cmpTotalEuros * 100);

        tvgLog("[velvet] totals", {
          baseUnitEuros,
          compareAtUnitEuros,
          areaCm2,
          unitsPerPanel,
          totalUnits,
          baseTotalCents,
          cmpTotalCents
        });

        // swap buttons: hide "calculate", show "add to cart"
        document.querySelector("#AddToCart-calc").classList.add("hide");
        document
          .querySelector(".add_cart_btn__hide")
          .classList.add("show_addtocart");

        const addBtn =
          document
            .querySelector(".product-single__meta")
            .querySelector("button[name='add'].bold_clone") ||
          document
            .querySelector(".product-single__meta")
            .querySelector("button[name='add']");

        if (addBtn) addBtn.style.display = "block";

        // finally render prices
        VelvetUpdatePrice(baseTotalCents, cmpTotalCents);
      },
      true
    );




    // --- 5) Velvet-specific render helper with logging ---
    function VelvetUpdatePrice(baseTotalCents, cmpTotalCents) {
      tvgLog("[velvet] VelvetUpdatePrice", { baseTotalCents, cmpTotalCents });

      // Base total
      productPriceElement.innerHTML = theme.Currency.formatMoney(
        baseTotalCents,
        theme.settings.moneyFormat
      );

      // Compare-at + savings (if we have a compare-at unit price)
      if (compareAtPriceElement && cmpTotalCents > 0) {
        compareAtPriceElement.innerHTML = theme.Currency.formatMoney(
          cmpTotalCents,
          theme.settings.moneyFormat
        );

        const savingsCents = cmpTotalCents - baseTotalCents;

        const spanForSavings = document.createElement("SPAN");
        spanForSavings.classList.add("prod-price-per-txt");
        spanForSavings.innerHTML = window.theme.strings.savePrice.replace(
          "[saved_amount]",
          theme.Currency.formatMoney(savingsCents, theme.settings.moneyFormat)
        );

        savePriceElement.innerHTML = "";
        savePriceElement.insertAdjacentElement("beforeend", spanForSavings);

        // make sure the wrappers are visible
        const compareWrapper = document.querySelector(".price-custom-hide");
        if (compareWrapper) compareWrapper.removeAttribute("hidden");

        const savingWrapper = document.querySelector(".saving-custom-hide");
        if (savingWrapper) savingWrapper.removeAttribute("hidden");
      }
    }
  } // end if (.custom-fields-velvet)


  // TVG 2025-11 – Area-based calculator (rectangular / circular)
  // quantity = Shopify "quantity" = number of 100cm² units
  function update_price(quantity) {
    const customFields        = document.querySelector(".custom-fields");
    const productPriceElement = document.querySelector("[data-product-price]");
    const perTextEl           = document.querySelector(".prod-price-per-txt");
    const qtyInput            = document.querySelector("input[name='quantity']");
    const template            = customFields
      ? customFields.getAttribute("data-product-template") || ""
      : "";

    const totalQty = Number(quantity) || 0;

    tvgLog("[custom-size] update_price init", {
        template: TVG_TEMPLATE_ID,
        kind: TVG_PRODUCT_KIND,
        totalQty
    });

    if (!customFields || !productPriceElement || !totalQty) {
      return;
    }

    // Unit price may be in euros ("40") or already in cents
    const unitAttr       = productPriceElement.getAttribute("content") || "";
    const unitPriceCents = tvgParseUnitCents(unitAttr);

    if (!unitPriceCents) {
      tvgLog("[custom-size] update_price - missing unit price", { unitAttr: unitAttr });
      return;
    }

    // We store quantity as "number of 100cm² units".
    // Convert that back to square metres for pricing:
    const unitsPerSquareMeter = 100;
    const areaM2              = totalQty / unitsPerSquareMeter;

    const updatedPriceCents = Math.round(unitPriceCents * areaM2);

    // Keep Shopify quantity input in sync
    if (qtyInput) {
      qtyInput.value = totalQty;
    }

    // Only handle the area-based templates here
    if (
      template === "product.custom-size-rectangular" ||
      template === "product.custom-size-circular"
    ) {
      // --- main price (total) + "per square metre" text ---
      productPriceElement.innerHTML = theme.Currency.formatMoney(
        updatedPriceCents,
        theme.settings.moneyFormat
      );

      if (perTextEl) {
        perTextEl.innerHTML =
          " (" +
          theme.Currency.formatMoney(
            unitPriceCents,
            theme.settings.moneyFormat
          ) +
          " " + window.theme.strings.per_square_metre + ")";
        productPriceElement.insertAdjacentElement("beforeend", perTextEl);
      }

      // --- TVG 2025-03 – compare-at + savings, scaled to total area ---
      const compareAtPriceElement = document.querySelector("[data-compare-price]");
      const savePriceElement      = document.querySelector("[data-save-price]");

      if (compareAtPriceElement) {
        const cmpAttrRaw = compareAtPriceElement.getAttribute("data-content") || "";
        const cmpUnitCents = tvgParseUnitCents(cmpAttrRaw);

        tvgLog("[custom-size] compare-at", {
          cmpAttrRaw: cmpAttrRaw,
          cmpUnitCents: cmpUnitCents,
          unitPriceCents: unitPriceCents
        });

        if (cmpUnitCents > 0 && unitPriceCents > 0) {
          const compareAtTotalCents = Math.round(cmpUnitCents * areaM2);
          const savingsCents        = compareAtTotalCents - updatedPriceCents;

          compareAtPriceElement.innerHTML = theme.Currency.formatMoney(
            compareAtTotalCents,
            theme.settings.moneyFormat
          );

          if (savePriceElement && savingsCents > 0) {
            const spanForSavings = document.createElement("SPAN");
            spanForSavings.classList.add("prod-price-per-txt");
            spanForSavings.innerHTML = window.theme.strings.savePrice.replace(
              "[saved_amount]",
              theme.Currency.formatMoney(savingsCents, theme.settings.moneyFormat)
            );

            savePriceElement.innerHTML = "";
            savePriceElement.insertAdjacentElement("beforeend", spanForSavings);
          }

          // make sure the wrappers are visible
          const compareWrapper = document.querySelector(".price-custom-hide");
          if (compareWrapper) compareWrapper.removeAttribute("hidden");

          const savingWrapper = document.querySelector(".saving-custom-hide");
          if (savingWrapper) savingWrapper.removeAttribute("hidden");
        }
      }
    }

    tvgLog("[custom-size] update_price done", {
      totalQty: totalQty,
      areaM2: areaM2,
      updatedPriceCents: updatedPriceCents
    });
  }

  // TVG 2025-11 – Length-based calculator (product.custom-length)
  // finalTotalCents = TOTAL base price in cents for all meters & pieces
  function updatePrice(finalTotalCents) {
    const productPriceElement   = document.querySelector("[data-product-price]");
    const compareAtPriceElement = document.querySelector("[data-compare-price]");
    const savePriceElement      = document.querySelector("[data-save-price]");

    if (!productPriceElement) {
      tvgLog("[length] updatePrice – missing product price element");
      return;
    }

    const unitAttr       = productPriceElement.getAttribute("content") || "";
    const unitPriceCents = tvgParseUnitCents(unitAttr);

    tvgLog("[length] updatePrice init", {
      finalTotalCents: finalTotalCents,
      unitAttr: unitAttr,
      unitPriceCents: unitPriceCents
    });

    // --- main price (total) ---
    productPriceElement.innerHTML = theme.Currency.formatMoney(
      finalTotalCents,
      theme.settings.moneyFormat
    );

    // --- "per metre" text = unit price per *cm* × 100 ---
    const perMeterCents = unitPriceCents * 100;

    const spanForPerMeter = document.createElement("SPAN");
    spanForPerMeter.classList.add("prod-price-per-txt");
    spanForPerMeter.innerHTML =
    " (" +
    theme.Currency.formatMoney(perMeterCents, theme.settings.moneyFormat) +
    " " + window.theme.strings.per_metre + ")";
    productPriceElement.insertAdjacentElement("beforeend", spanForPerMeter);


    // --- compare-at + savings, scaled to the same factor ---
    if (compareAtPriceElement) {
      const cmpAttrRaw  = compareAtPriceElement.getAttribute("data-content") || "";
      const baseAttrRaw = unitAttr || "";

      // Start from cents-ified values
      let cmpUnitCents    = tvgParseUnitCents(cmpAttrRaw);
      const baseUnitCents = unitPriceCents;

      // If compare-at has no decimal but base price does (e.g. "47" vs "0.38"),
      // Shopify has stored them on different scales. Normalise compare-at down by 100.
      if (cmpAttrRaw.indexOf(".") === -1 && baseAttrRaw.indexOf(".") !== -1) {
        cmpUnitCents = Math.round(cmpUnitCents / 100);
      }

      if (cmpUnitCents > 0 && baseUnitCents > 0) {
        const factor              = cmpUnitCents / baseUnitCents;
        const compareAtTotalCents = Math.round(finalTotalCents * factor);
        const savingsCents        = compareAtTotalCents - finalTotalCents;

        compareAtPriceElement.innerHTML = theme.Currency.formatMoney(
          compareAtTotalCents,
          theme.settings.moneyFormat
        );

        if (savePriceElement) {
          const spanForSavings = document.createElement("SPAN");
          spanForSavings.classList.add("prod-price-per-txt");
          spanForSavings.innerHTML = window.theme.strings.savePrice.replace(
            "[saved_amount]",
            theme.Currency.formatMoney(savingsCents, theme.settings.moneyFormat)
          );

          savePriceElement.innerHTML = "";
          savePriceElement.insertAdjacentElement("beforeend", spanForSavings);
        }
      }
    }

    tvgLog("[length] updatePrice done", {
      finalTotalCents: finalTotalCents,
      unitPriceCents: unitPriceCents
    });
  }



  /* --------------------------------------------------------
   * TVG 2025-11 – Variant change handling for velvet/fixed-width
   * --------------------------------------------------------
   * We do NOT reimplement the pricing logic here.
   * The main .custom-fields-velvet click handler already
   * calculates everything correctly based on:
   *   - current variant unit price (data-product-price content)
   *   - width/length
   *   - number of pieces
   *
   * All we need on variant change is to:
   *   - reset the UI to the "please confirm length" state
   *   - hide compare-at and savings
   *   - show the "Calculate price" button again
   *   - hide the Add to cart button
   * ------------------------------------------------------ */

  const variantChange = document.querySelector(".variant-input-wrap select");

  if (variantChange && document.querySelector(".custom-fields-velvet")) {
    variantChange.addEventListener("change", function (evt) {
      tvgLog("[velvet] variant change", { value: evt.target.value });

      // Put form back in "needs recalculation" mode
      parameterChanged();

      const productPriceElement   = document.querySelector("[data-product-price]");
      const compareAtPriceElement = document.querySelector("[data-compare-price]");
      const savePriceElement      = document.querySelector("[data-save-price]");
      const compareWrapper        = document.querySelector(".price-custom-hide");
      const savingWrapper         = document.querySelector(".saving-custom-hide");

      // Reset main price text to "Confirm length in cm"
      if (productPriceElement) {
        productPriceElement.innerHTML =
          window.theme.strings.custom_velvet_product;
        tvgLog("[velvet] variant change → reset price message");
      }

      // Hide compare-at + saving wrappers
      if (compareWrapper) compareWrapper.setAttribute("hidden", "hidden");
      if (savingWrapper)  savingWrapper.setAttribute("hidden", "hidden");

      // Clear any previous compare-at / saving content
      if (compareAtPriceElement) compareAtPriceElement.innerHTML = "";
      if (savePriceElement)      savePriceElement.innerHTML = "";

      // Ensure the Calculate Price button is visible and Add to cart hidden
      const priceCalculatingButton = document.querySelector("#AddToCart-calc");
      const addToCartWrapper       = document.querySelector(".add_cart_btn__hide");
      const addToCartButton =
        document.querySelector('.product-single__meta button[name="add"].bold_clone') ||
        document.querySelector('.product-single__meta button[name="add"]');

      if (priceCalculatingButton) priceCalculatingButton.classList.remove("hide");
      if (addToCartWrapper)       addToCartWrapper.classList.remove("show_addtocart");
      if (addToCartButton)        addToCartButton.style.display = "none";

      tvgLog("[velvet] variant change → UI reset complete");
    });
  }

})(); // end outer IIFE

